import type { Score as PolluxScore } from '@/interface/pollux';

export interface IScore {
    home: number;
    away: number;
}

export namespace IScore{
    export const fromPollux = (score: PolluxScore | undefined): IScore => ({
        home: score?.home ?? 0,
        away: score?.away ?? 0,
    });
}
